import { html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import { getGlobalStyleSheets } from '../../global-styles';
import { AtlAccordionClickEvent, AtlAccordionCollapseEvent, AtlAccordionProps } from './accordion.props';
import { AtlantisEvent } from '../helpers';

import * as TagNames from './accordion.tagnames';

@customElement(TagNames.Accordion)
export class AtlAccordion extends LitElement implements AtlAccordionProps {

    declare alwaysOpen?: boolean;

    static properties = {
        alwaysOpen: { attribute: 'always-open', type: Boolean }
    }

    static styles = [
        ...getGlobalStyleSheets()
    ];

    connectedCallback(): void {
        super.connectedCallback();
        this.addEventListener(AtlAccordionClickEvent.EVENT_NAME, this._handleAccordionItemClicked);
    }

    disconnectedCallback(): void {        
        this.removeEventListener(AtlAccordionClickEvent.EVENT_NAME, this._handleAccordionItemClicked);
        super.disconnectedCallback();
    }

    private _handleSlotChange = (e: AtlantisEvent<Event, HTMLSlotElement>) => {
        const assignedNodes = e.target.assignedNodes({ flatten: false }) as HTMLElement[];
        const accordionItems = assignedNodes.filter(node => node.nodeName === TagNames.AccordionItem.toUpperCase()) as HTMLElement[];
    
        if (accordionItems.length > 0) {
           accordionItems.forEach((accordionItem: HTMLElement, idx) => {
                if (idx === 0) {
                    accordionItem.setAttribute('first', "");                    
                } else {
                    accordionItem.removeAttribute('first');
                }
                
                if (idx === accordionItems.length - 1) {
                    accordionItem.setAttribute('last', "");
                } else {
                    accordionItem.removeAttribute('last')
                }
           });        
        }
    
        return this.updateComplete;
    };        

    render() {
        return html`
            <div class="accordion">
                <slot @slotchange=${this._handleSlotChange}></slot>
            </div>
        `;
    }

    private _handleAccordionItemClicked = (event: Event) => {
        if (this.alwaysOpen) return;

        const customEvent = event as AtlAccordionClickEvent;
        if (!customEvent.detail.opened) return;

        const slot = this.shadowRoot?.querySelector('slot');
        const slotNodes = slot?.assignedNodes({ flatten: false }) as HTMLElement[] ?? [];
        slotNodes.forEach((node: HTMLElement) => {
            node.dispatchEvent(new AtlAccordionCollapseEvent({ title: customEvent.detail.title }));
        });
    }
}